const RightToLeftBlockQuoteIcon = /*#__PURE__*/ [
  ["path", { d: "M7 6L15 6", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 12L15 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 18L15 18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M19 3L19 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export { RightToLeftBlockQuoteIcon as default };
//# sourceMappingURL=RightToLeftBlockQuoteIcon.js.map
